module.exports = __webpack_public_path__ + "static/media/apple-icon.42bc8f28.svg";